"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_FamilyMemberHistory = exports.FamilyMemberHistoryStatusKind = void 0;
var t = __importStar(require("io-ts"));
var RTTI_id_1 = require("../Scalar/RTTI_id");
var RTTI_Meta_1 = require("./RTTI_Meta");
var RTTI_uri_1 = require("../Scalar/RTTI_uri");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_code_1 = require("../Scalar/RTTI_code");
var RTTI_Narrative_1 = require("./RTTI_Narrative");
var RTTI_ResourceList_1 = require("../Union/RTTI_ResourceList");
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Identifier_1 = require("./RTTI_Identifier");
var RTTI_canonical_1 = require("../Scalar/RTTI_canonical");
var RTTI_CodeableConcept_1 = require("./RTTI_CodeableConcept");
var RTTI_Reference_1 = require("./RTTI_Reference");
var RTTI_dateTime_1 = require("../Scalar/RTTI_dateTime");
var RTTI_Period_1 = require("./RTTI_Period");
var RTTI_Age_1 = require("./RTTI_Age");
var RTTI_Range_1 = require("./RTTI_Range");
var RTTI_Annotation_1 = require("./RTTI_Annotation");
var RTTI_FamilyMemberHistory_Condition_1 = require("./RTTI_FamilyMemberHistory_Condition");
var FamilyMemberHistoryStatusKind;
(function (FamilyMemberHistoryStatusKind) {
    FamilyMemberHistoryStatusKind["_partial"] = "partial";
    FamilyMemberHistoryStatusKind["_completed"] = "completed";
    FamilyMemberHistoryStatusKind["_enteredInError"] = "entered-in-error";
    FamilyMemberHistoryStatusKind["_healthUnknown"] = "health-unknown";
})(FamilyMemberHistoryStatusKind = exports.FamilyMemberHistoryStatusKind || (exports.FamilyMemberHistoryStatusKind = {}));
var EnumType_1 = require("../../EnumType");
exports.RTTI_FamilyMemberHistory = t.recursion('IFamilyMemberHistory', function () {
    return t.intersection([
        t.type({
            resourceType: t.literal('FamilyMemberHistory'),
            patient: RTTI_Reference_1.RTTI_Reference,
            relationship: RTTI_CodeableConcept_1.RTTI_CodeableConcept
        }),
        t.partial({
            id: RTTI_id_1.RTTI_id,
            meta: RTTI_Meta_1.RTTI_Meta,
            implicitRules: RTTI_uri_1.RTTI_uri,
            _implicitRules: RTTI_Element_1.RTTI_Element,
            language: RTTI_code_1.RTTI_code,
            _language: RTTI_Element_1.RTTI_Element,
            text: RTTI_Narrative_1.RTTI_Narrative,
            contained: t.array(RTTI_ResourceList_1.RTTI_ResourceList),
            extension: t.array(RTTI_Extension_1.RTTI_Extension),
            modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
            identifier: t.array(RTTI_Identifier_1.RTTI_Identifier),
            instantiatesCanonical: t.array(RTTI_canonical_1.RTTI_canonical),
            instantiatesUri: t.array(RTTI_uri_1.RTTI_uri),
            _instantiatesUri: t.array(RTTI_Element_1.RTTI_Element),
            status: (0, EnumType_1.createEnumType)(FamilyMemberHistoryStatusKind, 'FamilyMemberHistoryStatusKind'),
            _status: RTTI_Element_1.RTTI_Element,
            dataAbsentReason: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
            date: RTTI_dateTime_1.RTTI_dateTime,
            _date: RTTI_Element_1.RTTI_Element,
            name: t.string,
            _name: RTTI_Element_1.RTTI_Element,
            sex: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
            bornPeriod: RTTI_Period_1.RTTI_Period,
            bornDate: t.string,
            _bornDate: RTTI_Element_1.RTTI_Element,
            bornString: t.string,
            _bornString: RTTI_Element_1.RTTI_Element,
            ageAge: RTTI_Age_1.RTTI_Age,
            ageRange: RTTI_Range_1.RTTI_Range,
            ageString: t.string,
            _ageString: RTTI_Element_1.RTTI_Element,
            estimatedAge: t.boolean,
            _estimatedAge: RTTI_Element_1.RTTI_Element,
            deceasedBoolean: t.boolean,
            _deceasedBoolean: RTTI_Element_1.RTTI_Element,
            deceasedAge: RTTI_Age_1.RTTI_Age,
            deceasedRange: RTTI_Range_1.RTTI_Range,
            deceasedDate: t.string,
            _deceasedDate: RTTI_Element_1.RTTI_Element,
            deceasedString: t.string,
            _deceasedString: RTTI_Element_1.RTTI_Element,
            reasonCode: t.array(RTTI_CodeableConcept_1.RTTI_CodeableConcept),
            reasonReference: t.array(RTTI_Reference_1.RTTI_Reference),
            note: t.array(RTTI_Annotation_1.RTTI_Annotation),
            condition: t.array(RTTI_FamilyMemberHistory_Condition_1.RTTI_FamilyMemberHistory_Condition)
        })
    ]);
});
//# sourceMappingURL=RTTI_FamilyMemberHistory.js.map